import { useNavigate } from "react-router-dom";
import { Box, Typography, Button, Card, CardContent } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";

export default function PaymentCancelledPage() {
  const navigate = useNavigate();

  const handleGoBackToTill = () => {
    // Go back to the previous page or till list
    navigate(-1);
  };

  const handleGoToTillList = () => {
    navigate("/till/list");
  };

  const handleGoHome = () => {
    navigate("/");
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        p: 3,
        bgcolor: "#f5f5f5",
      }}>
      <Card
        sx={{
          maxWidth: 500,
          width: "100%",
          textAlign: "center",
          boxShadow: 3,
        }}>
        <CardContent sx={{ p: 4 }}>
          <CancelIcon
            sx={{
              fontSize: 80,
              color: "warning.main",
              mb: 2,
            }}
          />
          <Typography variant="h4" gutterBottom color="warning.main">
            Payment Cancelled
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            Your payment was cancelled. No charges have been made to your
            account. You can try again or choose a different payment method.
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              alignItems: "center",
            }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleGoBackToTill}
              sx={{ minWidth: 180 }}>
              Try Payment Again
            </Button>

            <Box sx={{ display: "flex", gap: 2 }}>
              <Button
                variant="outlined"
                color="primary"
                onClick={handleGoToTillList}
                sx={{ minWidth: 120 }}>
                Go to Till List
              </Button>
              <Button
                variant="outlined"
                color="primary"
                onClick={handleGoHome}
                sx={{ minWidth: 120 }}>
                Go to Dashboard
              </Button>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
